import { useHookstate } from "@hookstate/core";
import AveragePace from "assets/svgIcons/AdminDashboard/AveragePace";
import PaceIcon from "assets/svgIcons/AdminDashboard/PaceIcon";
import {
  GlobalCourseIdState,
  SITEID_GLOBAL_STATE,
} from "globalStore/globalStore";
import moment from "moment";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { GiRabbit, GiTortoise } from "react-icons/gi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { API_STATUSES } from "redux/_helpers/statuses";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";

const DashboardPace = () => {
  const { t } = useTranslation();
  const { globalCourseId } = useHookstate(GlobalCourseIdState);
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const {
    dashboardPaceData,
    siteSettingsData,
    getDashboardFeatureSetStatus,
  } = useSelector((state) => state.commonReducers) || "";

  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  // Reusable styles
  const textColor = {
    green: "#63ad53",
    red: "#fa3c30"
  };

  const containerStyle = {
    display: "flex", 
    alignItems: "flex-start"
  };

  const textContainerStyle = {
    display: "flex", 
    flexDirection: "column", 
    alignItems: "flex-start"
  };

  const firstParagraphStyle = {
    margin: "0 0 8px 0", 
    padding: 0
  };

  const secondParagraphStyle = {
    margin: 0, 
    padding: 0
  };

  useEffect(() => {
    let courseId = globalCourseId.get();
    if (
      getDashboardFeatureSetStatus === API_STATUSES.SUCCESS &&
      siteId.get() !== null &&
      siteSettingsData &&
      Object.keys(siteSettingsData).length > 0
    ) {
      let LastQueryDate = moment(new Date())
        .utc()
        .utcOffset(-siteSettingsData?.TimeZoneOffset)
        .format("YYYY-MM-DD");
      dispatch(
        COMMON_SERVICES.getDashboardPaceServices(
          siteId.get(),
          LastQueryDate,
          localStorage.getItem("dashCourseId")
        )
      );
    }
  }, [
    getDashboardFeatureSetStatus,
    localStorage.getItem("dashCourseId"),
    siteId.get(),
    siteSettingsData,
  ]);

  return (
    <>
      <div className="header">
        <PaceIcon />
        <p>{t("Pace") + ": " + t("Fastest_pace") + "/" + t("Slowest_pace")}</p>
      </div>
      <div className="box-body pace-section">
        <div style={containerStyle}>
          <div><GiRabbit style={{ height: 50, width: 70 }}></GiRabbit></div>
          <div style={textContainerStyle}>
            <p style={firstParagraphStyle}>
              {t("Round_Start")}{" :  "}
              {dashboardPaceData && dashboardPaceData?.LastFastestPaceUpdated
                ? moment
                  .utc(dashboardPaceData?.LastFastestPaceUpdated)
                  .utcOffset(-siteSettingsData?.TimeZoneOffset)
                  .format("LT")
                : ""}
            </p>
            <p style={secondParagraphStyle}>
              <span style={{ color: textColor.green }}>{t("ahead")}</span>{"/"}<span style={{ color: textColor.red }}>{t("behind")}</span>{": "}
              <span style={{ color: textColor.green }}>{dashboardPaceData && dashboardPaceData?.FastestPace
                ? dashboardPaceData?.FastestPace < 0 ? <span style={{ color: textColor.red }}>{dashboardPaceData?.FastestPace * -1 + " " + t("min")}</span>
                  : <span style={{ color: textColor.green }}>{dashboardPaceData?.FastestPace + " " + t("min")}</span>
                : ""}</span>
            </p>
          </div>
        </div>
        <div style={containerStyle}>
          <div><GiTortoise style={{ height: 60, width: 70 }}></GiTortoise></div>
          <div style={textContainerStyle}>
            <p style={firstParagraphStyle}>
              {t("Round_Start")}{" :  "}
              {dashboardPaceData && dashboardPaceData?.LastSlowestPaceUpdated
                ? moment
                  .utc(dashboardPaceData?.LastSlowestPaceUpdated)
                  .utcOffset(-siteSettingsData?.TimeZoneOffset)
                  .format("LT")
                : ""}
            </p>
            <p style={secondParagraphStyle}>
              <span style={{ color: textColor.green }}>{t("ahead")}</span>{"/"}<span style={{ color: textColor.red }}>{t("behind")}</span>{": "}
              <span style={{ color: textColor.green }}>{dashboardPaceData && dashboardPaceData?.SlowestPace
                ? dashboardPaceData?.SlowestPace < 0 ? <span style={{ color: textColor.red }}>{dashboardPaceData?.SlowestPace * -1 + " " + t("min")}</span> :
                  <span style={{ color: textColor.green }}>{dashboardPaceData?.SlowestPace + " " + t("min")}</span>
                : ""}</span>
            </p>
          </div>
        </div>
        <div style={containerStyle}>
          <div><AveragePace style={{ height: 60, width: 70 }}></AveragePace></div>
          <div style={textContainerStyle}>
            <p style={firstParagraphStyle}>
              {t("Rounds_In_Progress") + " : "} {dashboardPaceData && dashboardPaceData?.TotalRounds}
            </p>
            <p style={secondParagraphStyle}>
              <span style={{ color: textColor.green }}>{t("ahead")}</span>{"/"}<span style={{ color: textColor.red }}>{t("behind")}</span>{": "}
              <span style={{ color: textColor.green }}>{dashboardPaceData && dashboardPaceData?.AveragePace
                ? dashboardPaceData?.AveragePace < 0 ? <span style={{ color: textColor.red }}>{dashboardPaceData?.AveragePace * -1 + " " + t("min")}</span> :
                  <span style={{ color: textColor.green }}>{dashboardPaceData?.AveragePace + " " + t("min")}</span>
                : ""}</span>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardPace;
